import { animated } from '@react-spring/web'
import { PaperBox } from 'src/components/Paper'
import styled from 'styled-components'

export type MenuItemProps = {
  children: string
  onClick: () => void
}

export const MenuItem = styled(animated.li)<MenuItemProps>`
  margin: 0;
  padding: 0 8px;
  line-height: 24px;
  height: 24px;
  list-style: none;
  cursor: default;
  &:hover {
    background-color: var(--hover);
    color: rgb(255, 255, 255);
  }
`

export const MenuWrapper = styled(PaperBox).attrs(props => ({
  ...props,
  style: { ...props.style, '--o': 1 }
}))`
  top: 64px;
  box-sizing: border-box;
  padding: 4px 0;
  margin: 0;
  min-width: 200px;
  min-height: 32px;
  background-color: rgb(255, 255, 255);
  position: fixed;
  left: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
`
